import { TriggerAggregationType } from './triggers.enum';
export var UnifiedAlertSource;
(function (UnifiedAlertSource) {
    UnifiedAlertSource["Logs"] = "LOGS";
    UnifiedAlertSource["Metrics"] = "METRICS";
})(UnifiedAlertSource || (UnifiedAlertSource = {}));
export var MetricTriggerType;
(function (MetricTriggerType) {
    MetricTriggerType["THRESHOLD"] = "threshold";
    MetricTriggerType["MATH"] = "math";
})(MetricTriggerType || (MetricTriggerType = {}));
export var ThresholdOperator;
(function (ThresholdOperator) {
    ThresholdOperator["ABOVE"] = "above";
    ThresholdOperator["BELOW"] = "below";
    ThresholdOperator["WITHIN_RANGE"] = "within_range";
    ThresholdOperator["OUTSIDE_RANGE"] = "outside_range";
})(ThresholdOperator || (ThresholdOperator = {}));
export var AlertOutputType;
(function (AlertOutputType) {
    AlertOutputType["Json"] = "JSON";
    AlertOutputType["Table"] = "TABLE";
})(AlertOutputType || (AlertOutputType = {}));
export var AlertType;
(function (AlertType) {
    AlertType[AlertType["Alert"] = 0] = "Alert";
    AlertType[AlertType["Rule"] = 1] = "Rule";
})(AlertType || (AlertType = {}));
// A const object, so the shared members reuse `TriggerAggregationType`.
export const AlertAggregationType = {
    AnyLogsFound: 'ANY_LOGS_FOUND',
    NoLogsFound: 'NO_LOGS_FOUND',
    NumberOfLogs: TriggerAggregationType.Count,
    Minimum: TriggerAggregationType.Min,
    Maximum: TriggerAggregationType.Max,
    Average: TriggerAggregationType.Avg,
    Sum: TriggerAggregationType.Sum,
    UniqueCount: TriggerAggregationType.UniqueCount,
    Percentage: 'PERCENTAGE',
    Percentile: 'PERCENTILE',
};
export var AlertNotificationSubject;
(function (AlertNotificationSubject) {
    AlertNotificationSubject["CreateAlert"] = "create-alert";
    AlertNotificationSubject["UpdateAlert"] = "update-alert";
    AlertNotificationSubject["DeleteAlert"] = "delete-alert";
    AlertNotificationSubject["NoAccessToAlert"] = "no-access-to-alert";
    AlertNotificationSubject["MaxAlertsReachedLimit"] = "max-alerts-reached-limit";
    AlertNotificationSubject["EnableAlertState"] = "enable-alert";
    AlertNotificationSubject["DisableAlertState"] = "disable-alert";
    AlertNotificationSubject["EnableAlertRca"] = "enable-alert-rca";
    AlertNotificationSubject["DisableAlertRca"] = "disable-alert-rca";
    AlertNotificationSubject["EmptyState"] = "empty-state";
})(AlertNotificationSubject || (AlertNotificationSubject = {}));
export var AlertCorrelationOperator;
(function (AlertCorrelationOperator) {
    AlertCorrelationOperator["And"] = "AND";
    AlertCorrelationOperator["AndThen"] = "AND_THEN";
})(AlertCorrelationOperator || (AlertCorrelationOperator = {}));
// In SG-139 we need to remove this enum
export var AlertOutputAmountSubject;
(function (AlertOutputAmountSubject) {
    AlertOutputAmountSubject["AllFields"] = "all-fields";
    AlertOutputAmountSubject["CustomFields"] = "custom-fields";
})(AlertOutputAmountSubject || (AlertOutputAmountSubject = {}));
export var AlertQueryDefinitionSubject;
(function (AlertQueryDefinitionSubject) {
    AlertQueryDefinitionSubject["QueryDefinition"] = "query-definition";
    AlertQueryDefinitionSubject["SearchString"] = "elasticsearch-query";
})(AlertQueryDefinitionSubject || (AlertQueryDefinitionSubject = {}));
export var AlertOutputSubject;
(function (AlertOutputSubject) {
    AlertOutputSubject["OutputTableEmptyState"] = "output-table-empty-state";
})(AlertOutputSubject || (AlertOutputSubject = {}));
export var AlertJoinQueriesSubject;
(function (AlertJoinQueriesSubject) {
    AlertJoinQueriesSubject["EmptyState"] = "join-table-empty-state";
    AlertJoinQueriesSubject["Table"] = "join-table";
    AlertJoinQueriesSubject["TableRow"] = "join-queries-table-row";
    AlertJoinQueriesSubject["JoinedField"] = "join-queries-joined-field";
})(AlertJoinQueriesSubject || (AlertJoinQueriesSubject = {}));
export var PreviewOutputSubject;
(function (PreviewOutputSubject) {
    PreviewOutputSubject["JSON"] = "output-preview-json";
    PreviewOutputSubject["TABLE"] = "output-preview-table";
})(PreviewOutputSubject || (PreviewOutputSubject = {}));
export var AlertDefinitionsSubject;
(function (AlertDefinitionsSubject) {
    AlertDefinitionsSubject["EmptyState"] = "alert-definitions-empty-state";
    AlertDefinitionsSubject["AlertDefinitionsContainer"] = "alert-definitions-container";
    AlertDefinitionsSubject["AlertToggleElement"] = "alert-toggle-element";
    AlertDefinitionsSubject["HeaderNewButton"] = "header-new-button";
})(AlertDefinitionsSubject || (AlertDefinitionsSubject = {}));
export var AlertSchedulingError;
(function (AlertSchedulingError) {
    AlertSchedulingError["EmptyCron"] = "EMPTY_CRON";
    AlertSchedulingError["LESS_THEN_MIN_GRANULARITY"] = "LESS_THEN_MIN_GRANULARITY";
    AlertSchedulingError["LESS_THEN_MIN_INTERVAL"] = "LESS_THEN_MIN_INTERVAL";
    AlertSchedulingError["INVALID_CRON"] = "INVALID_CRON";
})(AlertSchedulingError || (AlertSchedulingError = {}));
export var SortableFields;
(function (SortableFields) {
    SortableFields["name"] = "NAME";
    SortableFields["severity"] = "SEVERITY";
    SortableFields["createdAt"] = "CREATED_AT";
    SortableFields["updatedAt"] = "UPDATED_AT";
})(SortableFields || (SortableFields = {}));
export var FiltersIds;
(function (FiltersIds) {
    FiltersIds["severities"] = "severities";
    FiltersIds["createdBy"] = "createdBy";
    FiltersIds["updatedBy"] = "updatedBy";
    FiltersIds["activeState"] = "activeState";
    FiltersIds["tags"] = "tags";
    FiltersIds["search"] = "search";
})(FiltersIds || (FiltersIds = {}));
export var FiltersType;
(function (FiltersType) {
    FiltersType["severities"] = "MultiSelect";
    FiltersType["createdBy"] = "MultiSelect";
    FiltersType["updatedBy"] = "MultiSelect";
    FiltersType["activeState"] = "MultiSelect";
    FiltersType["tags"] = "MultiSelect";
})(FiltersType || (FiltersType = {}));
export var AlertScheduleSubject;
(function (AlertScheduleSubject) {
    AlertScheduleSubject["ScheduleToggle"] = "schedule-toggle";
    AlertScheduleSubject["CheckAlways"] = "always";
    AlertScheduleSubject["CheckOnSchedule"] = "on-schedule";
    AlertScheduleSubject["CronSchedule"] = "cron-schedule";
    AlertScheduleSubject["TimezoneSchedule"] = "timezone-schedule";
})(AlertScheduleSubject || (AlertScheduleSubject = {}));
export var AlertNotifySubject;
(function (AlertNotifySubject) {
    AlertNotifySubject["SuppressNotifications"] = "suppress-notifications";
    AlertNotifySubject["OutputFormat"] = "output-format";
    AlertNotifySubject["OutputFieldsAmount"] = "output-fields-amount";
    AlertNotifySubject["OutputLogFieldsTable"] = "output-log-fields-table";
})(AlertNotifySubject || (AlertNotifySubject = {}));
export var MenuActions;
(function (MenuActions) {
    MenuActions["Edit"] = "Edit";
    MenuActions["Duplicate"] = "Duplicate";
    MenuActions["ViewLastEvents"] = "View last events";
    MenuActions["Delete"] = "Delete";
    MenuActions["Contribute"] = "Contribute";
})(MenuActions || (MenuActions = {}));
//# sourceMappingURL=alerts.enum.js.map